'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var init = require('./init.js');

var errors = require('../errors.js');

var utils = require('../utils.js');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

function getVersion(_x) {
  return _getVersion.apply(this, arguments);
}

function _getVersion() {
  _getVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(backends) {
    var store;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return init.isRepoInitialized(backends);

          case 2:
            if (_context.sent) {
              _context.next = 4;
              break;
            }

            throw new errors.NotInitializedRepoError('Repo is not initialized!');

          case 4:
            store = backends.root;
            _context.next = 7;
            return store.open();

          case 7:
            _context.prev = 7;
            _context.t0 = parseInt;
            _context.t1 = toString;
            _context.next = 12;
            return store.get(utils.VERSION_KEY);

          case 12:
            _context.t2 = _context.sent;
            _context.t3 = _context.t1.toString.call(_context.t1, _context.t2);
            return _context.abrupt("return", (0, _context.t0)(_context.t3));

          case 15:
            _context.prev = 15;
            _context.next = 18;
            return store.close();

          case 18:
            return _context.finish(15);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7,, 15, 19]]);
  }));
  return _getVersion.apply(this, arguments);
}

function setVersion(_x2, _x3) {
  return _setVersion.apply(this, arguments);
}

function _setVersion() {
  _setVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(version, backends) {
    var store;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (backends) {
              _context2.next = 2;
              break;
            }

            throw new errors.MissingRepoOptionsError('Please pass repo options when trying to open a repo');

          case 2:
            store = backends.root;
            _context2.next = 5;
            return store.open();

          case 5:
            _context2.next = 7;
            return store.put(utils.VERSION_KEY, fromString.fromString(String(version)));

          case 7:
            _context2.next = 9;
            return store.close();

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setVersion.apply(this, arguments);
}

exports.getVersion = getVersion;
exports.setVersion = setVersion;